import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { SideNavBodyViewModel } from './side-nav-body-view-model';
import { BaseComponent } from '../../../../../models/base/base-component';
import { NavItem } from '../nav-item/models/nav-item';

@Component({
  selector: 'app-side-nav-body',
  standalone: false,
  templateUrl: './side-nav-body.component.html',
  styleUrl: './side-nav-body.component.scss',
  providers: [SideNavBodyViewModel],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SideNavBodyComponent extends BaseComponent {
  constructor(public viewModel: SideNavBodyViewModel) {
    super();
  }

  @Input() collapsed: boolean;
  @Output() expandSideNav = new EventEmitter<void>(true);

  public handleNavItemClickedSideEffects(navItem: NavItem): void {
    if (navItem?.subItems?.length > 0) {
      this.expandSideNav.emit();
    }
  }
}
